export var uploadSummaryOfCare = function (formData) {
    // Note: Not using kfetch since it defaults all requests to json and need to send as formData
    return fetch('/EhrWebApp/referrals/socupload', {
        body: formData,
        method: 'POST',
    });
};
